// livecategorytabs.js
import React from "react";
import "./create.css";

function LiveCategoryTabs({ players, selectedCategory, setSelectedCategory, handleSelect }) {
  const counts = {
    WK: players.filter((p) => p.role === "WK" && p.isSelected).length,
    BAT: players.filter((p) => p.role === "BAT" && p.isSelected).length,
    AR: players.filter((p) => p.role === "AR" && p.isSelected).length,
    BOW: players.filter((p) => p.role === "BOW" && p.isSelected).length,
  };

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-around">
        {Object.entries(counts).map(([cat, count]) => (
          <button
            key={cat}
            className={`btn ${selectedCategory === cat ? "btn-success" : "btn-outline-secondary"}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat} ({count})
          </button>
        ))}
      </div>

      {/* Players List */}
      <div className="list-group mt-3">
        {players
          .filter((p) => p.role === selectedCategory)
          .map((p) => (
            <div
              key={p.id}
              className={`list-group-item d-flex justify-content-between align-items-center ${p.isSelected ? "selected" : ""
                }`}
            >
              <div>
                <img
                  src={p.imageUrl || p.ImageUrl || p.playerImage || "/default-player.png"}
                  alt={p.name || p.PlayerName || "Player"}
                  className={`player-img ${p.isSelected ? "selected-img" : ""}`}
                  style={{ width: "40px", height: "40px", borderRadius: "50%", marginRight: "30px" }}
                />
                <span className={p.isSelected ? "text-white" : ""}>
                  {`${p.name || "Player"} | ${p.credits ?? p.credit ?? 0} | ${p.code || p.code || ""}`}
                </span>
              </div>
              <button
                className={`btn btn-sm ${p.isSelected ? "btn-danger" : "btn-success"}`}
                onClick={() => handleSelect(p.id)}
              >
                {p.isSelected ? "Remove" : "Add"}
              </button>
            </div>
          ))}
      </div>
    </div>
  );
}

export default LiveCategoryTabs;
